'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = require('reselect');

/**
 * Gets the platform from the state
 * @param {Map<*, *>} state The app state
 * @returns {String} desktop or mobile
 */
var getPlatform = function getPlatform(state) {
  return state.getIn(['settings', 'platform'], 'mobile');
};

/**
 * The memoized platform selector.
 */
exports.default = (0, _reselect.createSelector)([getPlatform], function (platform) {
  return platform;
});
//# sourceMappingURL=selectors.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-device-detection/dist/main/selectors.js
// module id = 519
// module chunks = 0